import UserList from "../../components/users/UserList";

export const signIn = (credentials) => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    
    firebase.auth().signInWithEmailAndPassword(
      credentials.email,
      credentials.password
    ).then(() => {
      dispatch({ type: 'LOGIN_SUCCESS' });
    }).catch((err) => {
      dispatch({ type: 'LOGIN_ERROR', err });
    });

  }
}

export const signOut = () => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();

    firebase.auth().signOut().then(() => {
      dispatch({ type: 'SIGNOUT_SUCCESS' })
    });
  }
}

export const signUp = (newUser, ccToken) => {
  return (dispatch, getState, {getFirebase, getFirestore}) => {
    (async () => {
    const firebase = getFirebase();
    //const firestore = getFirestore();

    if ((newUser.email === undefined || newUser.password === undefined || newUser.firstName === undefined || newUser.lastName === undefined || newUser.company === undefined || newUser.plan === undefined)
        || (newUser.email.length === 0 || newUser.password.length === 0 || newUser.firstName.length === 0 || newUser.lastName.length === 0 || newUser.company.length === 0) || newUser.plan.length === 0) {
          let err = {};
          err.message =  "All fields are required";
          dispatch({ type: 'SIGNUP_ERROR', err});
    }


    let resp = await firebase.auth().createUserWithEmailAndPassword(
      newUser.email, 
      newUser.password
    ); //.then(resp => {
      
      console.log("Signing up " + newUser);
      console.log("CC token " + ccToken);
      console.log("User ID is " + firebase.auth.uid);
      let req = {};
      req.email=newUser.email;
      req.phone=newUser.phone;
      req.fname=newUser.firstName;
      req.lname=newUser.lastName;
      req.company=newUser.company;
      req.userID=resp.user.uid;

      //var request = new Request('https://us-central1-multilanguage-dacbe.cloudfunctions.net/newCompany', {
      let rawResponse = await fetch('https://us-central1-multilanguage-dacbe.cloudfunctions.net/newCompany', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(req)
      });


      //fetch(request).then(results => {
        
        let company = newUser.company;
        let email = newUser.email;
        let ccReq = {};
        ccReq.stripeToken=ccToken.id;
        ccReq.stripeTokenType=ccToken.type;
        ccReq.stripeEmail=email;
        ccReq.companyName=company;

        let response = await fetch("https://us-central1-multilanguage-dacbe.cloudfunctions.net/confirmPay", {
            method: "POST",
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(ccReq)
        });
  
        if (response.ok) console.log("CC verification Complete!")
        
      
      rawResponse = await fetch('https://us-central1-multilanguage-dacbe.cloudfunctions.net/newPlan', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({userID: resp.user.uid, planName: newUser.plan})
      });
      const planResponse = await rawResponse;
    
      console.log(planResponse);

        dispatch({ type: 'SIGNUP_SUCCESS' });
      //}).catch((err) => {
        //dispatch({ type: 'SIGNUP_ERROR', err});
      //});
  
    //});
  })();
  }
}

export const invite = (newUser, companyName, projectName) => {
  return (dispatch, getState) => {
    (async () => {
  
        const state = getState();
        let req = {};
        req.email=newUser.email;
        req.phone=newUser.phone;
        req.name=newUser.firstName + " " + newUser.lastName;
        req.company=companyName;
        req.project=projectName;
        req.trade=newUser.trade;
        req.userID=state.firebase.auth.uid;
        
        const rawResponse = await fetch('https://us-central1-multilanguage-dacbe.cloudfunctions.net/inviteUser', {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(req)
        });
      
      
      dispatch({type: 'INVITATION_SENT'});
  
    })();
    }
}

export const checkProvisioning = (user) => {
  return (dispatch, getState, {getFirebase}) => {
      
      if (user === null || user === undefined) {
        dispatch({ type: 'LOGIN_ERROR', error: "Error logging into Construwise.  Please call support." });
        return;
      } 
      if ((user.provisioned === undefined) || (user.provisioned === false)) {
        dispatch({ type: 'PROVISION_CHECKED_SUCCESS', provisioned : false});
        
      } else {
        dispatch({ type: 'PROVISION_CHECKED_SUCCESS', provisioned : true});
      }
      
    
  }
}

export const checkCompanyOwnership = (user) => {
  return (dispatch, getState, {getFirebase}) => {
      
    (async () => {
  
      const state = getState();
      let req = {};
      req.filterName="firebaseID";
      req.filterValue=state.firebase.auth.uid;
      
      const rawResponse = await fetch('https://atheredev.appspot.com/user?filterName=firebaseID&filterValue='+state.firebase.auth.uid, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        }
      });
    
      let resp = await rawResponse.json();
      let ownedCompanies = [];
      if (resp !== undefined && resp.companies !== undefined) {
        for (var i = 0; i < resp.companies.length; i++) {
          if (resp.companies[i].isOwner !== undefined && resp.companies[i].isOwner === true) {
            ownedCompanies.push(resp.companies[i].name);
          }
        }
      }
      
      dispatch({type: 'OWNEDCOMPANIES_CHECKED_SUCCESS', ownedCompanies: ownedCompanies});

    })();
  }
}

export const signInWithGoogle = () => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    var provider = new firebase.auth.GoogleAuthProvider();
    firebase.auth().signInWithRedirect(provider).then(() => {

      let user = getState().firebase.data.users[getState().firebase.auth.uid];
      if (user === null || user === undefined) {
        dispatch({ type: 'LOGIN_ERROR', error: "Error logging into Construwise.  Please call support." });
        return;
      } 
      if ((user.provisioned === undefined) || (user.provisioned === false)) {
        dispatch({ type: 'LOGIN_SUCCESS_NOT_PROVISIONED'});
        return;
      }
      dispatch({ type: 'LOGIN_SUCCESS' });
    }).catch((err) => {
      dispatch({ type: 'LOGIN_ERROR', err });
    });
  }
}

export const signInWithPhone = () => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    
    var applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
    var provider = new firebase.auth.PhoneAuthProvider();
    var phone = window.prompt('Please enter your ten digit phone number (XXXXXXXXXX). \nFor international codes, use a \'+\' followed by the country code.');
    if (phone.length === 10) {
      phone = "+1" + phone;
    } 
    if (!phone.startsWith("+")) {
      phone = "+" + phone;
    }
    provider.verifyPhoneNumber(phone, applicationVerifier)
    .then (function(verificationId) {
      window.alert("Press okay once the verification code is received."); //Hack.  Captcha dismisses this alert.  
      var code = window.prompt('Please enter verification code.');

      return firebase.auth.PhoneAuthProvider.credential(verificationId,
        code);
    })  
    .then(function(phoneCredential) {
      return firebase.auth().signInWithCredential(phoneCredential);
    })
    .then(() => {
      dispatch({ type: 'LOGIN_SUCCESS' });
    }).catch((err) => {
      dispatch({ type: 'LOGIN_ERROR', err });
    });
  }
}




// WEBPACK FOOTER //
// ./src/store/actions/authActions.js